module.exports = __webpack_public_path__ + "img/vertical_4_4_5010.32e42ad0.png";